module.exports = __webpack_public_path__ + "img/p-communication.5174accf.png";